import Businesses from './Businesses';

export default Businesses;
